import {
  ChevronLeft,
  ChevronRight,
  Clock,
  Mail,
  MapPin,
  MoveRight,
  Phone,
  Quote,
  Star,
} from "lucide-react";
import {
  UserRoundCheck,
  Ambulance,
  Stethoscope,
  BadgeDollarSign,
  HeartHandshake,
} from "lucide-react";

import { useState, useEffect } from "react";
import { images } from "../assets/assets";
import Navbar from "../Components/Navbar";
import MedicalServices from "../Sections/HomePage/MedicalServices";
import HealtCareExperts from "../Sections/HomePage/HealtCareExperts";
import SocialHandle from "../Sections/HomePage/SocialHandle";
import Blogs from "../Sections/HomePage/Blogs";
import { Link } from "react-router-dom";
import Footer from "../Components/Footer";
import Notifications from "../Components/Notifications";
import HealthResources from "../Components/AyushmanYoutube";


const HomePage = () => {
  const [heroIndex, setHeroIndex] = useState(0);
  const [testimonialIndex, setTestimonialIndex] = useState(0);

  const HeroSectionData = [
    {
      img: images.Banner1,
      desc: "NABH Accredited - Ayushman Empanelled. 150 Bedded Hospital in Nakur - Saharanpur.",
      subDesc: "Treatments + Infrastructure + Trauma Center",
      rating: "4.9",
      review: "Based on Google Reviews",
    },
    {
      img: images.Banner2,
      desc: "NABH Accredited - Ayushman Empanelled. 150 Bedded Hospital in Nakur - Saharanpur.",
      subDesc: "Treatments + Infrastructure + Trauma Center",
      rating: "5",
      review: "Based on Google Reviews",
    },
    // Add more hero slides here as needed
  ];

  // Auto-slide hero section every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setHeroIndex((prevIndex) =>
        prevIndex === HeroSectionData.length - 1 ? 0 : prevIndex + 1,
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [HeroSectionData.length]);

  const testimonials = [
    {
      quote: "Very good hospital with caring doctors and staff.",
      name: "Rajesh Nair",
      role: "Patient",
      img: images.Testimonial,
    },
    {
      quote:
        "Excellent treatment and very hygienic environment. Highly recommended.",
      name: "Sunita Gupta",
      role: "Patient",
      img: images.Testimonial,
    },
    {
      quote:
        "The doctors were very attentive and the emergency team responded quickly.",
      name: "Mohit Verma",
      role: "Patient",
      img: images.Testimonial,
    },
  ];

const whyChoose = [
  {
    icon: UserRoundCheck,
    heading: "Experienced & Qualified Doctors",
    para: "Experienced and highly qualified doctors you trust",
    iconClass: "w-16 h-16 text-[#1976D2]",
  },
  {
    icon: Ambulance,
    heading: "24×7 Emergency & Ambulance Services",
    para: "24×7 emergency care with quick ambulance support",
    iconClass: "w-16 h-16 text-[#E53935]",
  },
  {
    icon: Stethoscope,
    heading: "Advanced Diagnostic Facilities",
    para: "Advanced diagnostic facilities with modern equipment",
    iconClass: "w-16 h-16 text-[#009688]",
  },
  {
    icon: BadgeDollarSign,
    heading: "Affordable Treatment Plans",
    para: "Quality care with affordable and flexible treatment plans",
    iconClass: "w-16 h-16 text-[#43A047]",
  },
  {
    icon: HeartHandshake,
    heading: "Personalized Care & Attention",
    para: "Individualized treatment with focused patient care approach",
    iconClass: "w-16 h-16 text-[#EC407A]",
  },
];

  // const whyChoose = [
  //   {
  //     icon: images.ChooseOne,
  //     heading: "Experienced & Qualified Doctors",
  //     para: "Experienced and highly qualified doctors you trust",
  //     iconClass: "w-[61px] h-[77px]",
  //   },
  //   {
  //     icon: images.ChooseTwo,
  //     heading: "24×7 Emergency & Ambulance Services",
  //     para: "24×7 emergency care with quick ambulance support",
  //     iconClass: "w-[100px] h-[78px]",
  //   },
  //   {
  //     icon: images.ChooseThree,
  //     heading: "Advanced Diagnostic Facilities",
  //     para: "Transparent pricing with affordable treatment options available",
  //     iconClass: "w-[100px] h-[76px]",
  //   },
  //   {
  //     icon: images.ChooseFour,
  //     heading: "Affordable Treatment Plans",
  //     para: "Quality care with affordable and flexible treatment plans",
  //     iconClass: "w-[80px] h-[80px]",
  //   },
  //   {
  //     icon: images.ChooseFive,
  //     heading: "Personalized Care & Attention",
  //     para: "Individualized treatment with focused patient care approach",
  //     iconClass: "w-[106px] h-[80px]",
  //   },
  // ];

  const prevHero = () =>
    setHeroIndex((p) => (p === 0 ? HeroSectionData.length - 1 : p - 1));
  const nextHero = () =>
    setHeroIndex((p) => (p === HeroSectionData.length - 1 ? 0 : p + 1));

  const prevTestimonial = () =>
    setTestimonialIndex((p) => (p === 0 ? testimonials.length - 1 : p - 1));
  const nextTestimonial = () =>
    setTestimonialIndex((p) => (p === testimonials.length - 1 ? 0 : p + 1));

  const currentHero = HeroSectionData[heroIndex];
  const currentTestimonial = testimonials[testimonialIndex];

  return (
    <div className="font-lato">
      <Navbar />

      {/*  Hero Section  */}
      <div className="relative h-[400px] sm:h-[480px] md:h-[570px] w-full overflow-hidden">
        {/* Slides Container */}
        <div
          className="flex h-full transition-transform duration-700 ease-in-out"
          style={{
            transform: `translateX(-${heroIndex * 100}%)`,
          }}
        >
          {HeroSectionData.map((hero, idx) => (
            <div key={idx} className="relative w-full h-full flex-shrink-0">
              <img
                src={hero.img}
                alt="Hero"
                className="w-full h-full object-cover"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-[#00000080]" />

              {/* Text */}
              <div className="absolute inset-0 flex items-center justify-center px-6 md:px-12">
                <div className="max-w-[900px] text-white text-center">
                  <p className="font-bold text-[22px] sm:text-[32px] md:text-[36px] leading-tight">
                    {hero.desc}
                  </p>
                  <p className="mt-3 font-medium text-[16px] sm:text-[20px] md:text-[20px]">
                    {hero.subDesc}
                  </p>
                </div>
              </div>

              {/* Rating Badge */}
              <div
                className="flex items-center gap-2 p-2 sm:p-3 rounded-[10px] bg-[#8A8A8A99] absolute bottom-7 sm:bottom-4 left-6 md:left-12"
                style={{ backdropFilter: "blur(5.7px)" }}
              >
                <div className="flex gap-1 text-[#FFC712]">
                  {Array.from({
                    length: Math.ceil(Number(hero.rating) || 0),
                  }).map((_, i) => (
                    <Star
                      key={i}
                      className="w-[14px] h-[14px] sm:w-[17px] h-[17px] md:w-[18px] md:h-[18px] fill-[#FFC712]"
                    />
                  ))}
                </div>
                <div className="flex flex-col text-white">
                  <p className="text-[14px] sm:text-[16px] md:text-[20px] font-bold">
                    {hero.rating}/5 Rating
                  </p>
                  <p className="text-[12px] sm:text-[13px] md:text-[16px]">
                    {hero.review}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Left Arrow */}
        {HeroSectionData.length > 1 && (
          <button
            onClick={prevHero}
            className="z-50 absolute top-1/2 -translate-y-1/2 left-4 md:left-6 p-1.5 border-2 border-white text-white hover:bg-white hover:text-black active:scale-90 rounded-full transition-all duration-200"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
        )}

        {/* Right Arrow */}
        {HeroSectionData.length > 1 && (
          <button
            onClick={nextHero}
            className="z-50 absolute top-1/2 -translate-y-1/2 right-4 md:right-6 p-1.5 border-2 border-white text-white hover:bg-white hover:text-black active:scale-90 rounded-full transition-all duration-200"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        )}

        {/* Slide dots */}
        {HeroSectionData.length > 1 && (
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-40">
            {HeroSectionData.map((_, i) => (
              <button
                key={i}
                onClick={() => setHeroIndex(i)}
                className={`h-2 rounded-full transition-all duration-200 ${
                  i === heroIndex ? "bg-white w-5" : "bg-white/50 w-2"
                }`}
              />
            ))}
          </div>
        )}
      </div>
      {/* notification */}
      <Notifications />
{/* ayushman bharat and youtube channel logo */}
     <HealthResources/>
      

      {/*  Welcome Note  */}
      <div className="mt-8 md:mt-10 flex flex-col justify-center items-center px-4">
        <h1 className="text-black font-bold text-[24px] md:text-[38px] text-center">
          Welcome to Dev Rishi Hospital
        </h1>
        <p className="text-black font-medium text-[15px] md:text-[19px] max-w-[928px] mx-auto text-center mt-2">
          Dev Rishi Hospital is dedicated to providing world-class healthcare
          services with compassion, innovation, and excellence. Since our
          establishment, we have focused on delivering patient-first care backed
          by advanced medical technology. Our hospital is equipped with modern
          infrastructure, highly trained medical professionals, and a commitment
          to continuous improvement. We understand that healthcare is not just
          about treating illnesses — it's about caring for people and improving
          lives.
        </p>
        <Link
          to="/about"
          className="w-fit bg-[#1975FF] rounded-[10px] py-1 pr-1 pl-4 flex items-center gap-2 text-[14px] md:text-[15px] font-semibold text-white mt-6 hover:bg-[#1560d4] active:bg-[#1050b8] active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg group"
        >
          Learn more about us{" "}
          <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
            <MoveRight color="#000" className="rotate-[-38deg] w-4 h-4" />
          </span>
        </Link>
      </div>

      {/*  Why Choose  */}
      <div className="mt-12 md:mt-16 text-black flex flex-col items-center px-4">
        <h1 className="text-[22px] md:text-[32px] font-semibold text-center">
          Why Choose Dev Rishi Hospital?
        </h1>
        <p className="max-w-[774px] text-center text-[15px] md:text-[18px] mb-4 mt-2">
          Choosing Dev Rishi Hospital means choosing trusted expertise, modern
          medical care, and a compassionate environment where every patient is
          treated with dignity, respect, and personalized attention.
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-5 gap-3 md:gap-4 max-w-[1200px] mx-auto mt-3 w-full">
          {whyChoose.map((item, idx) => {
            const Icon = item.icon;

            return <div
              key={idx}
              className="p-4 md:p-5 border border-[#B9B9B9] text-center rounded-[8px] hover:border-[#1975FF] hover:shadow-md hover:-translate-y-1 active:translate-y-0 active:shadow-none transition-all duration-250 cursor-default group"
            >
              {item.icon && (
                <Icon
                  className={`${item.iconClass} mx-auto mb-3 md:mb-4 text-[#1975FF] e transition-all duration-300`}
                  strokeWidth={1.4}
                />
              )}
              <p className="text-[14px] md:text-[18px] font-semibold">
                {item.heading}
              </p>
              <p className="text-[#545454] text-[13px] md:text-[16px] mt-1">
                {item.para}
              </p>
            </div>
          })}
        </div>
      </div>

      {/*  Banner Image  */}
      <Link to={"/ayushman"}>
        <img
          src={images.Banner2}
          alt="Ayushman"
          className="h-[200px] sm:h-[280px] md:h-[400px] w-[80%] mx-auto my-8 md:my-10 mt-12 md:mt-15 rounded-[16px] md:rounded-[20px] object-cover"
        />
      </Link>
      <MedicalServices />
      <HealtCareExperts />

      {/*  Book Appointment  */}
      <div className="py-10 md:py-12 bg-[#F7F7F7B2] px-4">
        <h1 className="max-w-[550px] text-center text-[22px] md:text-[32px] font-semibold mx-auto leading-[1.2]">
          Book your appointment today for expert care and quick consultation.
        </h1>
        <p className="max-w-[600px] font-openSans text-[15px] md:text-[18px] mx-auto text-center mt-3">
          Get expert consultation from our experienced doctors without long
          waiting times. Book your appointment now for quick and hassle-free
          healthcare services.
        </p>
        <div className="flex flex-wrap gap-4 justify-center mt-8">
          <Link
            to="/appointment"
            className="bg-[#1975FF] rounded-[10px] py-1 pr-1 pl-4 flex items-center gap-2 text-[14px] font-semibold text-white hover:bg-[#1560d4] active:bg-[#1050b8] active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg group"
          >
            Book Appointment{" "}
            <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
              <MoveRight color="#000" className="rotate-[-38deg] w-4 h-4" />
            </span>
          </Link>
          <a
            href="tel:+917300906444"
            className="border border-black rounded-[10px] py-0.5 px-4 flex items-center gap-2 text-[14px] font-semibold text-black hover:bg-black hover:text-white active:scale-95 transition-all duration-200"
          >
            <span className="p-2 bg-[#F59E0B] rounded-full">
              <Phone color="#ffffff" className="w-4 h-4" />
            </span>
            Call Now
          </a>
        </div>
      </div>

      {/*  Testimonials  */}
      <div className="bg-white py-10 md:py-12 px-4">
        <h3 className="text-[22px] md:text-[28px] font-semibold text-center mb-6">
          What Our Patients Say
        </h3>
        <div className="flex gap-6 md:gap-14 items-center justify-center">
          <button
            onClick={prevTestimonial}
            className="p-2 border-2 border-black text-black hover:bg-black hover:text-white active:scale-90 rounded-full transition-all duration-200 flex-shrink-0"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>

          <div className="bg-[#FBFBFB] p-6 md:p-8 rounded-[20px] shadow-sm max-w-[501px] w-full transition-all duration-300">
            <Quote className="w-6 h-6 text-black rotate-180 mb-2" />
            <blockquote className="text-black font-medium text-[16px] md:text-[22px]">
              "{currentTestimonial.quote}"
            </blockquote>
            <div className="flex gap-2 items-center justify-center mt-6">
              <img
                src={currentTestimonial.img}
                alt="testimonial"
                className="w-[48px] h-[48px] md:w-[51px] md:h-[49px] rounded-full object-cover"
              />
              <div>
                <p className="text-base text-[#1F2933] font-bold">
                  {currentTestimonial.name}
                </p>
                <p className="text-[#5F5F5F] text-[13px]">
                  {currentTestimonial.role}
                </p>
              </div>
            </div>
            {/* Dots */}
            <div className="flex justify-center gap-2 mt-4">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setTestimonialIndex(i)}
                  className={`h-2 rounded-full transition-all duration-200 ${
                    i === testimonialIndex
                      ? "bg-[#1975FF] w-5"
                      : "bg-gray-300 w-2"
                  }`}
                />
              ))}
            </div>
          </div>

          <button
            onClick={nextTestimonial}
            className="p-2 border-2 border-black text-black hover:bg-black hover:text-white active:scale-90 rounded-full transition-all duration-200 flex-shrink-0"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>

      <SocialHandle />
      <Blogs />

      {/*  Emergency CTA  */}
      <div className="py-10 md:py-12 bg-[#F7F7F7B2] px-4">
        <h1 className="max-w-[550px] text-center text-[22px] md:text-[32px] font-semibold mx-auto leading-[1.2]">
          Need Immediate Medical Attention?
        </h1>
        <p className="max-w-[480px] font-openSans text-[15px] md:text-[18px] mx-auto text-center mt-3">
          For urgent medical needs, contact our emergency team available 24×7
          for quick and reliable care.
        </p>
        <div className="flex justify-center mt-8">
          <a
            href="tel:+917300906444"
            className="bg-[#E00F1D] rounded-[10px] py-1 pr-1 pl-4 flex items-center gap-2 text-[14px] font-semibold text-white hover:bg-[#b80d18] active:bg-[#900b13] active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg group"
          >
            <Phone color="#ffffff" className="w-4 h-4" />
            +91 7300906444
            <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
              <MoveRight color="#000" className="rotate-[-38deg] w-4 h-4" />
            </span>
          </a>
        </div>
      </div>
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HomePage;
